/** Whether the dashboard should show the Cloud Spend top-line stat. */
export function shouldShowCloudSpend(tokenUsage) {
  return tokenUsage?.cloud_spend_visible === true;
}

/** Dashboard stats row column count for flex layout (lg+). */
export function dashboardStatsColumnCount({ isAdmin, showCloudSpend }) {
  if (isAdmin) {
    return showCloudSpend ? 5 : 4;
  }
  return showCloudSpend ? 3 : 2;
}
